(function () {
  if (window.EreenaLookbook) {
    window.EreenaLookbook.init(document);
    return;
  }

  class LookbookSection {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll(".lookbook__look"));
      this.activeIndex = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains("is-active"))
      );
      this.pointerStart = null;

      this.bindEvents();
      this.setLook(this.activeIndex);
      root.dataset.lookbookInitialized = "true";
    }

    bindEvents() {
      this.root.addEventListener("click", (event) => {
        const productTrigger = event.target.closest("[data-lookbook-product-trigger]");
        if (productTrigger && this.root.contains(productTrigger)) {
          const slide = productTrigger.closest(".lookbook__look");
          this.setProduct(slide, productTrigger.dataset.productIndex);
          return;
        }

        const lookTrigger = event.target.closest("[data-lookbook-look-trigger]");
        if (lookTrigger && this.root.contains(lookTrigger)) {
          this.setLook(Number(lookTrigger.dataset.lookIndex));
          return;
        }

        const action = event.target.closest("[data-lookbook-action]");
        if (!action || !this.root.contains(action)) return;

        const direction = action.dataset.lookbookAction === "next" ? 1 : -1;
        this.setLook(this.activeIndex + direction);
      });

      const stage = this.root.querySelector(".lookbook__stage");
      if (!stage || this.slides.length < 2) return;

      stage.addEventListener("pointerdown", (event) => {
        if (event.target.closest("a, button")) return;
        this.pointerStart = { x: event.clientX, y: event.clientY };
      });

      stage.addEventListener("pointerup", (event) => {
        if (!this.pointerStart) return;

        const distanceX = event.clientX - this.pointerStart.x;
        const distanceY = event.clientY - this.pointerStart.y;
        this.pointerStart = null;

        if (Math.abs(distanceX) < 50 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
        this.setLook(this.activeIndex + (distanceX < 0 ? 1 : -1));
      });

      stage.addEventListener("pointercancel", () => {
        this.pointerStart = null;
      });
    }

    setLook(index) {
      if (!this.slides.length) return;

      this.activeIndex = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.activeIndex;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", String(!isActive));
      });

      this.root.querySelectorAll("[data-lookbook-look-trigger]").forEach((trigger) => {
        const isActive = Number(trigger.dataset.lookIndex) === this.activeIndex;
        trigger.classList.toggle("is-active", isActive);
        trigger.setAttribute("aria-current", String(isActive));
      });
    }

    setProduct(slide, productIndex) {
      if (!slide) return;

      const products = Array.from(slide.querySelectorAll("[data-lookbook-product]"));
      const selectedProduct = products.find((product) => product.dataset.productIndex === productIndex);
      if (!selectedProduct) return;

      products.forEach((product) => {
        const isActive = product === selectedProduct;
        product.classList.toggle("is-active", isActive);
        product.hidden = !isActive;
      });

      slide.querySelectorAll("[data-lookbook-product-trigger]").forEach((trigger) => {
        const isActive = trigger.dataset.productIndex === productIndex;
        trigger.classList.toggle("is-active", isActive);
        trigger.setAttribute("aria-current", String(isActive));
        if (trigger.classList.contains("lookbook__hotspot")) {
          trigger.setAttribute("aria-pressed", String(isActive));
        }
      });
    }

    selectBlock(blockId) {
      const slideIndex = this.slides.findIndex((slide) => slide.dataset.blockId === blockId);
      if (slideIndex !== -1) this.setLook(slideIndex);
    }
  }

  const init = (scope) => {
    const roots = [];

    if (scope.matches?.(".js-lookbook")) roots.push(scope);
    scope.querySelectorAll?.(".js-lookbook").forEach((root) => roots.push(root));

    roots.forEach((root) => {
      if (root.dataset.lookbookInitialized === "true") return;
      root.lookbook = new LookbookSection(root);
    });
  };

  window.EreenaLookbook = { init };

  init(document);

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:block:select", (event) => {
    const root = event.target.closest(".js-lookbook");
    root?.lookbook?.selectBlock(event.detail.blockId);
  });
})();
